export default "__VITE_ASSET__6b522b0a__"